import * as ActionTypes from "../Types/ActionTypes";

export const RegisterUser = (
  state = {
    isLoading: true,
    errMess: null,
    registerUser: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.REGISTER_SET_DATA:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        registerUser: action.payload,
      };
    // case ActionTypes.FETCH_registerUserID:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: null,
    //     registerUserId: action.payload,
    //   };

    // case ActionTypes.registerUser_LOADING:
    //   return {
    //     ...state,
    //     isLoading: true,
    //     errMess: null,
    //     registerUser: [],
    //     registerUserId: [],
    //   };

    // case ActionTypes.registerUser_FAILED:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: action.payload,
    //     registerUser: [],
    //     registerUserId: [],
    //   };

    default:
      return state;
  }
};
